const ProjectData = [
  {
    count: "0",
    img: "/images/blog.png",
    projectHeading: "1. Django Blog Platform",
    workingLink: "https://djangoblog49.onrender.com",
    SoftUsed1: "Django",
    ProjDespriction:
      "Design and developed a Django blog application emphasizing CRUD functionality (Create, Read, Update, Delete) Django templates for the frontend using PostgreSQL database and deployed on render. Implemented key features such as blog search & filtering with Tags and headline.",
    SoftUsed2: "AWS",
    SoftUsed3: "Javascript",
    SoftUsed4: "Fullstack",
    link: "https://github.com/shreevatsnandan/Quotes-app",
  },
  {
    count: "2",
    img: "/images/MERN.png", // Make sure this image exists in your assets
    projectHeading: "2. MERN Stack Application",
    workingLink: "https://mern-deploy-july.onrender.com",
    SoftUsed1: "MERN",
    ProjDespriction:
      "A modern full-stack web application built with the MERN stack, showcasing RESTful API integration, responsive React frontend, and robust backend logic using Node.js and Express. Emphasizes modular architecture, JWT-based authentication, and React Router for SPA navigation.",
    SoftUsed2: "Mongodb",
    SoftUsed3: "Render",
    SoftUsed4: "Fullstack",
    link: "",
  },
  {
    count: "0",
    img: "/images/paypal.png",
    projectHeading: "3. Django PayPal Integration",
    workingLink: "https://django-paypal49.onrender.com",
    SoftUsed1: "Django",
    ProjDespriction:
      "An e-commerce transaction system integrated with PayPal for secure payments. Demonstrates real-world payment gateway implementation using Django views, PayPal REST API, and secure order handling logic.",
    SoftUsed2: "Paypal",
    SoftUsed3: "AWS",
    SoftUsed4: "Fullstack",
    link: "https://github.com/shreevatsnandan/Quotes-app",
  },
  {
    count: "2",
    img: "/images/django-react.png", // Make sure this image exists in your assets
    projectHeading: "4. Django React E-commerce Website",
    workingLink: "https://django-deploy-final.onrender.com",
    SoftUsed1: "MERN",
    ProjDespriction:
      "A modern full-stack web application built with the MERN stack, showcasing RESTful API integration, responsive React frontend, and robust backend logic using Node.js and Express. Emphasizes modular architecture, JWT-based authentication, and React Router for SPA navigation.",
    SoftUsed2: "Mongodb",
    SoftUsed3: "Render",
    SoftUsed4: "Fullstack",
    link: "",
  },
   {
    count: "0",
    img: "/images/album49.png",
    projectHeading: "5. Django Photo Album",
    workingLink: "https://django-photoalbum-2025.onrender.com",
    SoftUsed1: "Django",
    ProjDespriction:
      "An e-commerce transaction system integrated with PayPal for secure payments. Demonstrates real-world payment gateway implementation using Django views, PayPal REST API, and secure order handling logic.",
    SoftUsed2: "Paypal",
    SoftUsed3: "AWS",
    SoftUsed4: "Fullstack",
    link: "https://github.com/shreevatsnandan/Quotes-app",
  },
  
];

export default ProjectData;
